<template>
  <div>
    <div class="step-title">{{ stepTitle }}</div>
    <progressBar :count="totalStep" :value="step" />
    <serviceLightStep1 v-if="step == 1" @nextStep="nextStep" />
    <serviceLightStep2
      v-if="step == 2"
      @previousStep="previousStep"
      @nextStep="nextStep"
    />
    <serviceLightStep3
      v-if="step == 3"
      @previousStep="previousStep"
      @nextStep="nextStep"
    />
    <serviceLightStep4
      v-if="step == 4"
      @previousStep="previousStep"
      @pay="pay"
    />
    <serviceLightStep5 v-if="step == 5" :orderStatus="orderStatus" />
  </div>
</template>

<script>
import store from 'Store/store';
import serviceLightStep1 from 'Pages/ServiceModule/ServiceLight/ServiceLightStep1.vue';
import serviceLightStep2 from 'Pages/ServiceModule/ServiceLight/ServiceLightStep2.vue';
import serviceLightStep3 from 'Pages/ServiceModule/ServiceLight/ServiceLightStep3.vue';
import serviceLightStep4 from 'Pages/ServiceModule/ServiceLight/ServiceLightStep4.vue';
import serviceLightStep5 from 'Pages/ServiceModule/ServiceLight/ServiceLightStep5.vue';
import progressBar from 'Components/progress/progressBar.vue';

export default {
  name: 'Service1',
  components: {
    progressBar,
    serviceLightStep1,
    serviceLightStep2,
    serviceLightStep3,
    serviceLightStep4,
    serviceLightStep5,
  },
  data() {
    return {
      totalStep: 5,
      currentStep: 1,
      stepTitles: [
        '服務說明',
        '填寫申請人資料',
        '填寫祈福人資料',
        '確認申請內容',
        '付款',
      ],
    };
  },
  mounted() {
    this.$emit('getOrderStatus');
  },
  computed: {
    enabled() {
      return store.state.main.onlineStatus.lightInfo.enable;
    },
    step() {
      return this.currentStep;
    },
    stepTitle() {
      return this.stepTitles[this.currentStep - 1];
    },
    orderStatus() {
      return store.state.main.orderStatus;
    },
  },
  methods: {
    previousStep() {
      this.currentStep -= 1;
      window.scrollTo({ behavior: 'auto', top: 0 });
    },
    nextStep() {
      if (this.currentStep == 1 && false === this.enabled) {
        store.dispatch('main/showErrorMsg', { msg: '線上點燈尚未開放' });
        return;
      }
      this.currentStep += 1;
      window.scrollTo({ behavior: 'auto', top: 0 });
    },
    showResult() {
      this.currentStep = this.totalStep;
    },
    pay(paymentInfo) {
      store.dispatch('main/bookingLight', paymentInfo);
    },
    clearApplyInfo() {
      store.dispatch('main/clearLightApplyInfo');
    },
  },
};
</script>

<style>
.step-title {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin: 29px 5px 10px 5px;
}
</style>
